module.exports = __webpack_public_path__ + "static/UnclickPassedAwayYellow-243621ffe833afe2d31356f9bed744a4.png";